import {deserialize} from 'libs/cerialize';

export class SearchTypeModel {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}